// JsFromRoutes CacheKey 42fc26ad9f36823138c814700dc92235
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  sendTestEmail: /* #__PURE__ */ definePathHelper('post', '/update-contact/prompts/send_test_email'),
}
